import { Component, ViewChild, OnInit, ViewEncapsulation, TemplateRef , Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ImageResult } from 'ngx-image2dataurl';
import { LocalStorage } from 'ngx-store';
import { ToastrService } from 'ngx-toastr';
import * as moment from "moment";
import {DaterangepickerDirective} from 'ngx-daterangepicker-material';
import { formatDate } from '@angular/common';
import { saveAs } from 'file-saver';

//Model
import { FileExport } from '../../../model/exporter.model';
import { ThemeSetting } from '../../../model/users.model';
import { Url, User} from '../../../model/users.model';
import { OtherCost } from '../../../model/othercost.model';

//Service
import { ExportService } from '../../../services/exporter.service';
import { FleetAssetsService } from '../../../services/fleetassets.service';
import { FilesService } from '../../../services/files.service';

@Component({
    selector: 'app-othercost',
    templateUrl: './othercost.component.html',
    styleUrls: ['../../datatable.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [FilesService, FleetAssetsService]
  })
  
  export class OtherCostComponent implements OnInit {
    @LocalStorage() url!: Url;
    @LocalStorage() user: User;
    @LocalStorage() themeSettings: ThemeSetting;

    public fileStoragePath = this.url.fileStorage;

    othercost_rows = [];

    drivers = [];
    fleet = [];
    providers = [];
    payment_statuses = [];

    selected5 = [];
    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    isEditMode: boolean = false;

    showDate:boolean=true;
    showRego:boolean=true;
    showFleetID:boolean=true;
    showSupplier:boolean=true;
    showCost:boolean=true;
    showFile:boolean=true;

    public otherCostForm: FormGroup;
    public modalRef: NgbModalRef;

    public othercost: OtherCost;

    public frmFile: any;
    public fileExists :boolean;
    public fileRemove :boolean;
    public oldFile: string;

    public readonly prefixCost = 'othercosts';
    public readonly prefixFleetAssets = "fleetassets";
    public readonly prefixFleetDetails = "fleetdetails";
    
    othercostYearly: number;
    othercostMonthly: number;
    othercostWeekly: number;
    othercostRecentCost: number;
    othercostRecentRego: string;
    othercostRecentDate: string;
    loadingIndicator5: boolean = true;

    myDropDown='7';
    dateFilter='Last 7 Days';


    public otherCostDateRange: any =[];
    locale: any = {
      format: 'DD MMMM YYYY',
      displayFormat: 'DD MMMM YYYY',
      separator: ' to ',
      cancelLabel: 'Cancel',
      applyLabel: 'OK',
    }
    maxDate: moment.Moment = moment();

    totalOtherCostAmount: any;
    totalOtherCost: number = 0;
    averageOtherCostAmount: any;

    public showSidebar : boolean = false;

    //Handles the name, type and content of the to-be exported file
    public exp_excel: FileExport;
    public exp_pdf: FileExport;
    
    //Stores the filtered and formatted content of the file
    formatted_list : any;
    spinner: boolean = false;
    driver_id:any;

    @Input() othercosts: OtherCost[];
    @Input() parent: string;
    @Input() fleet_id :number; 
    @Output() refreshData : EventEmitter<any>= new EventEmitter<any>();
    @ViewChild('modalOtherCost', { static: false }) modalOtherCost: TemplateRef<any>;
    @ViewChild('modalDeleteOtherCost', { static: false }) modalDeleteOtherCost: TemplateRef<any>;
    @ViewChild(DaterangepickerDirective, {static: false}) daterangepicker: DaterangepickerDirective;

    constructor(private http: HttpClient, private _fb: FormBuilder, private modal: NgbModal, private toastr: ToastrService, 
                private fileService: FilesService, private fleetAssetsService: FleetAssetsService, private exporter: ExportService){
    }

    ngOnInit() {
        this.initOtherCostForm();
        this.resetFileVariables();
        this.getOtherCosts(this.myDropDown);

        this.exp_excel = {title:'', list_data:'', type:''};
        this.exp_pdf = {title:'', list_data:'', type:''};
    }


    othercost_columns = [
        { prop: 'id' },
        { prop: 'rego' },
        { prop: 'driver' },
        { prop: 'fleet_id' },
        { prop: 'driver_id' },
        { prop: 'provider_id' },
        { prop: 'date' },
        { prop: 'date_due' },
        { prop: 'cost' },
        { prop: 'company_name' },
        { prop: 'file' },
        { prop: 'status' },
        { prop: 'payment_status_id'},
        { prop: 'description'}

        ];

    initOtherCostForm () {
      const currencyRegex = '^[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$';
      const numbers = '^[0-9]+$';
      this.otherCostForm = this._fb.group({
        id: [''],
        fleet_id: [''],
        driver_id: [''],
        provider_id: [''],
        user_id: [''],
        description: ['', Validators.required],
        details: [''],
        cost: ['', [Validators.required, Validators.pattern(currencyRegex)]],
        date: ['', Validators.required],
        date_due: [''],
        mileage: ['', Validators.pattern(numbers)],
        fault: [''],
        payment_status_id: ['', Validators.required],
        file: [''],
        rego: [''],
        driver: [''],
        provider: [''],
        user: [this.user.display_name] // needed for logs

    });
    }

    isCost() {
		const frmCtrl = (<any>this.otherCostForm);

		if (frmCtrl.controls.cost.valid)
			return true;
		else return false;
  }

    onSelect5({ selected5 }) {
      console.log('Select Event', selected5, this.selected5);
    }
  
    onActivate5(event5) {
      console.log('Activate Event', event5);
    }

    openOtherCostModal(othercost: OtherCost): void {

      if(othercost){
        this.isEditMode = true;
        this.othercost = othercost;
        this.otherCostForm.patchValue(this.othercost);
        this.otherCostForm.controls.user.setValue(this.user.display_name);

         if (this.othercost.file != null && this.othercost.file != '')
        {
          this.oldFile = this.othercost.file;
          this.fileExists = true;
        }
   
      } 
      else{
        this.isEditMode = false;
        this.othercost = new OtherCost();
        this.otherCostForm.reset();
        this.otherCostForm.controls.user.setValue(this.user.display_name);

        //fleet_id is preset if come from fleetdetails component
        var fleet_value = '';
        if(this.fleet_id){fleet_value = this.fleet_id.toString();};
        this.otherCostForm.controls.fleet_id.setValue(fleet_value);
      }   
      this.modalRef = this.modal.open(this.modalOtherCost, { size: 'lg', backdrop: 'static'});
    
      this.modalRef.result.then((result) => {
        this.otherCostForm.reset();
      }, (reason) => {
        this.otherCostForm.reset();
      });
    }

   
    openDeleteOtherCostModal(othercost: OtherCost) {

      if(othercost){
        this.othercost = othercost;
      } 
      this.modalRef = this.modal.open(this.modalDeleteOtherCost, { size: 'sm', backdrop: 'static'});     
    }

    public getOtherCosts (myDropdown,start='', end=''){
      setTimeout(() => { }, 100);
      if (!this.fleet_id){
  
        this.fleetAssetsService.getOtherCosts(myDropdown,start, end).subscribe(data => {
          this.othercost_rows = data['othercosts'];
          if(this.othercost_rows.length>0 && this.othercost_rows != null){
          this.selected5 = [this.othercost_rows[0]];
          this.otherCount = Object.keys(this.othercost_rows).length;
          }
          else{
            this.selected5=[];
          }
  
          this.fullRowsOther = this.othercost_rows;
          this.tempOther = this.othercost_rows;
          this.othercostYearly = data['othercost_yearly'];
          this.othercostMonthly = data['othercost_monthly'];
          this.othercostWeekly = data['othercost_weekly'];
          this.othercostRecentCost = data['othercost_recent_cost'];
          if( data['othercost_recent_rego'] !== null){
            this.othercostRecentRego = data['othercost_recent_rego']['fleet_id_num'] + '(' + data['othercost_recent_rego']['rego']  + ')';
          }else{ this.othercostRecentRego = '-';};
          this.othercostRecentDate = data['othercost_recent_date'];
          this.computeOtherCostSubtotals();
          this.http.get(this.url.rest + '/tms/getFleetAssetsMisc').subscribe(data => {
          
              this.drivers = data["drivers"];
              this.fleet = data['fleet'];
              this.payment_statuses = data['payment_statuses'];
      
              setTimeout(() => { 
                this.loadingIndicator5 = false; 
               }, 100);
              
          });
  
          this.fleetAssetsService.getProvidersOthers().subscribe(data =>{
            this.providers = data['providers'];
          });

     
          setTimeout(() => { this.loadingIndicator5 = false; }, 100);
      });
      
      }
      else{
        this.fleetAssetsService.getOtherCostFleetId(this.fleet_id,myDropdown,start,end).subscribe(data=>{
         
          this.othercost_rows = data['othercosts'];
          
          this.computeOtherCostSubtotals(); 
          this.fullRowsOther = this.othercost_rows;
          if (typeof this.othercost_rows != "undefined"  && this.othercost_rows != null  
          && this.othercost_rows.length != null  && this.othercost_rows.length > 0) {
              this.selected5 = [this.othercost_rows[0]];
          }  
          else{
            this.selected5=[];
          }

          this.http.get(this.url.rest + '/tms/getFleetAssetsMisc').subscribe(data => {
          
            this.drivers = data["drivers"];
            this.fleet = data['fleet'];
            this.payment_statuses = data['payment_statuses'];
    
            setTimeout(() => { 
              this.loadingIndicator5 = false; 
             }, 100);
            
        });
          this.fleetAssetsService.getProvidersOthers().subscribe(data =>{
            this.providers = data['providers'];
          });

          setTimeout(() => { this.loadingIndicator5 = false; }, 100);
      })
      this.getOtherCostsDashboard();
      }
    }

    public getOtherCostsDashboard(){
         
      if(this.parent == this.prefixFleetDetails){
          this.fleetAssetsService.getOtherCostSummaryByFleetId(this.fleet_id).subscribe(data=>{
              this.othercostYearly = data['othercost_yearly'];
              this.othercostMonthly = data['othercost_monthly'];
              this.othercostWeekly = data['othercost_weekly'];
              this.othercostRecentCost = data['othercost_recent_cost'];
              if( data['othercost_recent_rego'] ! == null){
                this.othercostRecentRego = data['othercost_recent_rego']['fleet_id_num'] + '(' + data['othercost_recent_rego']['rego']  + ')';
              }else{ this.othercostRecentRego = '-';}
              this.othercostRecentDate = data['othercost_recent_date'];

              setTimeout(() => { this.loadingIndicator5 = false; }, 100);
          })
      }
  }

  onChangeofOptions(selected) {
    console.log('changing to', selected);
    if (selected == 'week') {
        this.myDropDown =  'week'
        this.dateFilter = 'This Week'
        this.showFilters = false;
        this.getOtherCosts(this.myDropDown);
    }
    else
    if (selected == 'month') {
        this.myDropDown =  'month'
        this.dateFilter = 'Month'
        this.showFilters = false;
        this.getOtherCosts(this.myDropDown);
    }
    else 
    if (selected == 'year') {
        this.myDropDown =  'year'
        this.dateFilter = 'This Year'
        this.showFilters = false;
        this.getOtherCosts(this.myDropDown);
    }
    else
    if (selected == 'today') {
        this.myDropDown =  'today'
        this.dateFilter = 'Today'
        this.showFilters = false;
        this.getOtherCosts(this.myDropDown);
    }
    else
    if (selected == '7') {
        this.myDropDown =  '7'
        this.dateFilter = 'Last 7 Days'
        this.showFilters = false;
        this.getOtherCosts(this.myDropDown);
    }
    else
    if (selected == '14') {
        this.myDropDown =  '14'
        this.dateFilter = 'Last 14 Days'
        this.showFilters = false;
        this.getOtherCosts(this.myDropDown);
    }
    else
    if (selected == '30') {
        this.myDropDown =  '30'
        this.dateFilter='Last 30 Days'
        this.showFilters = false;
        this.getOtherCosts(this.myDropDown);
    }
    else
    if (selected == '90') {
        this.myDropDown =  '90'
        this.dateFilter = 'Last 90 Days'
        this.showFilters = false;
        this.getOtherCosts(this.myDropDown);
    }
    else
    if (selected == 'range') {
        this.myDropDown =  'range'
        this.dateFilter = 'range'
        this.showFilters = true;
        // this.getOtherCosts(this.myDropDown);
        this.processOtherCostDateRange('');
    }
    else if(selected == "all"){
      this.showFilters = true;
      this.getOtherCosts("all");
    }
}

processOtherCostDateRange(event) {
  console.log('processing range');
  
  // if (event.start != undefined && event.end != undefined){
  var start = moment(this.otherCostDateRange.start?._d).format('YYYY-MM-DD');
  var end = moment(this.otherCostDateRange.end?._d).format('YYYY-MM-DD');
  console.log(start + ' to ' + end);
  this.getOtherCosts('range',start, end);
  // }
}



computeOtherCostSubtotals() {
  this.totalOtherCostAmount = 0;
  this.totalOtherCost = 0;
  if (this.othercost_rows[0]) {
      let sum: number = this.othercost_rows.map(a => a.cost).reduce(function(a, b)
      {
      return a + b;
      });
      this.totalOtherCostAmount = sum;

      this.totalOtherCost = this.othercost_rows.length;
  }
  this.averageOtherCostAmount = (this.totalOtherCostAmount / this.totalOtherCost) || 0;
}
  
  
    async createOtherCost(othercost: OtherCost) {
        this.spinner = true;
        await this.fleetAssetsService.createOtherCost(othercost).toPromise().then(result => {
            this.toastr.success('', result['message'], {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
              });
        }).catch(err =>{
            this.toastr.error("Please try again.", "There was a problem with creating new other cost entry.", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
            });
        }).finally(() => {
            this.getOtherCosts(this.myDropDown); 
        });
        this.spinner = false;
    }

    async updateOtherCost(othercost:OtherCost) {
      this.spinner = true;
        await this.fleetAssetsService.updateOtherCost(othercost).toPromise().then(result => {
            this.toastr.success('', result['message'], {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
              });
        }).catch(err =>{
            this.toastr.error("Please try again.", "There was a problem with updating the selected other cost entry.", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
            });
        }).finally(() => {
            this.refreshData.emit();
            this.getOtherCosts(this.myDropDown);  
        });  
        this.spinner = false;
    }

 
    async deleteOtherCost(othercost: OtherCost) {
        this.spinner = true;

        if(othercost.file != null && othercost.file != ''){
        this.deleteFile(this.prefixCost, othercost.file);
        }

        await this.fleetAssetsService.deleteOtherCost(othercost.id).toPromise().then(result=> {
            this.toastr.success('', result['message'], {
                timeOut: 5000,
                positionClass: 'toast-top-full-width',
                progressBar: true
              });
        }).catch(err =>{
            this.toastr.error("Please try again.", "There was a problem with deleting the selected other cost entry.", {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
          }).finally(() => {
            this.refreshData.emit();
            this.getOtherCosts(this.myDropDown);  
          });
        this.modalRef.close();  
        this.spinner = false;  
    }

    public closeModal(){
        this.modalRef.close();
        this.spinner = false;
        this.ngOnInit();
    }

    verifyDateValuesOtherCost(){
      if( (this.otherCostForm.value.date != "" && !moment(this.otherCostForm.value.date, "YYYY-MM-DD", true).isValid()) ){
        return false;
      }
      else return true;
    }

    showInvalidDateToastr(){
      this.toastr.error('', 'Entered an invalid date!', {
          timeOut: 2000,
          positionClass: 'toast-top-full-width',
          progressBar: true
      });
    }

    async onSubmitOtherCost(othercost: OtherCost) {
      if(this.verifyDateValuesOtherCost()){
        this.spinner = true;
        this.othercost = othercost;

        if (this.otherCostForm.valid) {
        this.othercost = othercost;
        
        if(othercost.id){
            this.updateOtherCost(this.othercost);
        }
        else{
            
            console.log('creating other cost...');
            await this.fleetAssetsService.createOtherCost(othercost).toPromise().then(result => {
                this.toastr.success('', result['message'], {
                    timeOut: 5000,
                    positionClass: 'toast-top-full-width',
                    progressBar: true
                  });
            }).catch(err =>{
                this.toastr.error("Please try again.", "There was a problem with creating new other cost entry.", {
                  timeOut: 5000,
                  positionClass: 'toast-top-full-width',
                  progressBar: true
                });
              }).finally(() => {
                this.refreshData.emit();
              });
            this.getOtherCosts(this.myDropDown);
        }   

        this.uploadFile(this.prefixCost, this.othercost.file);
        this.closeModal(); 
        }
      }
      else this.showInvalidDateToastr();
    }


    public getFile(event, caller){

        var assetFilename;

        if (event == '' || event == null){
        assetFilename = event
        }else{
        var file : ImageResult;
        file = event;
        assetFilename =  file.file.name;

        this.frmFile = event;
        }

        switch (caller){
       case this.prefixCost: 
            { this.otherCostForm.controls.file.setValue(assetFilename); break;};
        default: break;
        }
    }

    public uploadFile(caller, filename){
        if (this.frmFile){
        this.fileService.uploadRawFile(caller, this.frmFile, filename).subscribe(file=>{
        });
        
        }

        this.frmFile = '';

        //handling files if replaced, old file is removed from server
        if(this.fileRemove == true){
            this.deleteFile(caller, this.oldFile);
        };
    }

    public removeFile(caller){
        this.fileExists  = false;

        switch (caller){
        case this.prefixCost:
            { this.otherCostForm.controls.file.setValue(''); break;};
        default: break;
        }
        
        this.fileRemove = true;
    }

    public deleteFile(caller, filename){
        this.fileService.deleteFile(caller, filename).subscribe(result=>{console.log(result);})
        this.fileRemove = false;
        this.refreshData.emit();       

    }

    public resetFileVariables(){
        // for document file handling variables; checking if file exists or removed
            this.fileExists = false;
            this.fileRemove  = false;
            this.oldFile = '';
    }

    public isNumber(value) {
        if (isNaN(value) ) {
        return false;
        }
        else return true;
    }

    print(caller: string): void {
        let printContents, popupWin;
        printContents = document.getElementById('print-section-' + caller).innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
        <html>
        <head>
        <title>Fleet Other Costs</title>
        <style>
        @page {
            size: A4;
        }

        table {
            border-collapse: collapse;
            border-spacing: 0;
            width: 100%;
            border: 1px solid #ddd !important;
        }

        th, td {
            text-align: left;
            padding: 16px;
        }


        tr:nth-child(even) {
            background-color: #f2f2f2 !important;
            box-shadow: inset 0 0 0 1000px #f2f2f2;
        }

        .fn {
        float: footnote;
        }

        thead {
        box-shadow: inset 0 0 0 1000px #f2f2f2;
        }
        
            
        </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
        </html>`
        );
        popupWin.document.close();
    }

    public toggleFilters() {
        if (this.showFilters) this.showFilters = false;
        else this.showFilters = true;
    }

    toggleSideBar(){
      if(this.showSidebar== false){
        this.loadingIndicator = true;
        this.showSidebar = true;
        setTimeout(() => { this.loadingIndicator = false; }, 100);
      }else{
        this.loadingIndicator = true;
        this.showSidebar = false;
        setTimeout(() => { this.loadingIndicator = false; }, 100);
      }
      this.getOtherCosts(this.myDropDown);
    }

  //Filter Codes

    showFilters: boolean = false;
    filterOtherRego: string = '';
    filterOtherProvider: string = '';
    filterOtherDateFrom: Date;
    filterOtherDateTo: Date;
    isFilterEmpty: boolean = true;
    tempOther = [];
    fullRowsOther = [];
    otherCount = 0;
    summaryCount = 0;
    summaryTotalCost = 0;



    updateFilter(caller:string) {
        this.isFilterEmpty = false;
        
        switch (caller){
        case this.prefixCost :{
          this.tempOther = this.fullRowsOther.filter(data => {
            if (this.filterOtherRego){
              if(data.rego || data.rego!==null){
                return data.rego.toLowerCase().indexOf(this.filterOtherRego.toLowerCase()) !== -1 || !this.filterOtherRego.toLowerCase();      
              }
            }else{
              return data.rego  ||  data.rego == null;
            };
          });
            
          this.tempOther = this.tempOther.filter(data => { //if field is not a required field
            if (this.filterOtherProvider){
              if (data.provider_id  || data.provider_id!==null){
                  return data.provider_id == this.filterOtherProvider;
              }
            }else{
                return data.provider_id ||  data.provider_id == null;
            };
          });

            this.tempOther = this.tempOther.filter(data => { 
            if (data.date && (this.filterOtherDateFrom && this.filterOtherDateTo)){
                return new Date(data.date) >= new Date(this.filterOtherDateFrom) && new Date(data.date) <= new Date(this.filterOtherDateTo);      
            }else{
                return data.date;
            };
            });

            this.getOtherCostsSummary(this.tempOther)
            this.othercost_rows = this.tempOther;  
            this.otherCount = Object.keys(this.tempOther).length;
            if(this.othercost_rows.length>0){
              this.selected5 = [this.othercost_rows[0]]
          }else{
              this.selected5 = [];
          }
  
          this.totalOtherCostAmount = 0;
          this.totalOtherCost = 0;
          if (this.othercost_rows[0]) {
              let sum: number = this.othercost_rows.map(a => a.cost).reduce(function(a, b)
              {
              return a + b;
              });
              this.totalOtherCostAmount = sum;
      
              this.totalOtherCost = this.othercost_rows.length;
          }
          this.averageOtherCostAmount = (this.totalOtherCostAmount / this.totalOtherCost) || 0;
    
        }

        default: {break;}
        }
    }

    public resetFilters() {
      this.filterOtherRego = '';
      this.filterOtherDateFrom = null;
      this.filterOtherDateTo = null;
      this.filterOtherProvider = '';
      this.othercost_rows = this.fullRowsOther;
      this.otherCount = this.othercost_rows.length;
      this.isFilterEmpty = true;
      this.summaryCount = 0;
      this.summaryTotalCost = 0;
      this.otherCostDateRange=[];
      this.getOtherCosts(this.myDropDown);
    }

    public getOtherCostsSummary(tempOther){
        this.summaryTotalCost = 0; this.summaryCount = 0;    
        if(tempOther.length === this.fullRowsOther.length){
          this.summaryTotalCost = 0;
          this.summaryCount = 0;    
        } else {
          for(let i = 0; i < tempOther.length; i++){
            this.summaryTotalCost = this.summaryTotalCost + tempOther[i].cost;
          }
          this.summaryCount = tempOther.length;
        }
      }

       /*** Export... Module ***/
  //Replaces an attribute name for reading comprehension
  renameKey( obj, oldKey, newKey ) {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  }

  //Formats readable header names in the given table
  generateHeaders(list_fleetAsset): any{
      const arr = JSON.parse(list_fleetAsset);
      arr.forEach( obj => {
      this.renameKey( obj, 'date', 'Date' );
      this.renameKey( obj, 'rego', 'REGO' );
      this.renameKey( obj, 'fleet_id_num', 'Fleet ID' );
      this.renameKey( obj, 'company_name', 'Supplier' );
      this.renameKey( obj, 'cost', 'Cost' );
      this.renameKey( obj, 'file', 'File' );
      });
      const updatedJson = JSON.stringify( arr );
      return updatedJson;
  }

  //Filters every column in the Other Cost table list
  otherCost_generateColumnsWithFilter(list_otherCost){
      const arr = JSON.parse(JSON.stringify(list_otherCost));
      arr.forEach( obj => {

        obj['date'] = formatDate(obj['date'], 'dd MMM yyyy', 'en_US');

          //remove filtered columns
          if(!this.showDate){
              delete obj['date'];
          };
          if(!this.showRego){
              delete obj['rego'];
          };
          if(!this.showFleetID){
              delete obj['fleet_id_num'];
          };
          if(!this.showSupplier){
              delete obj['company_name'];
          };
          if(!this.showCost){
              delete obj['cost'];
          };
          if(!this.showFile){
              delete obj['file'];
          };
          delete obj['id'];
          delete obj['driver'];
          delete obj['fleet_id'];
          delete obj['driver_id'];
          delete obj['provider_id'];
          delete obj['date_due'];
          delete obj['status'];
          delete obj['payment_status_id'];
          delete obj['description'];
      });
      const updatedJson = JSON.stringify( arr );
      return updatedJson;                         
  }

  //Exports Other Costs table to CSV file
  otherCost_exportToCSV(){
      if(this.othercost_rows.length >0){
          let with_header_format, with_column_filter;
          
          //generate json with filtered column
          with_column_filter = this.otherCost_generateColumnsWithFilter(this.othercost_rows);

          //generate json with format header
          this.formatted_list = this.generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let csv_file = '[TMS]Fleet_Asset_Other_Costs_' + this.formattedDate(current_date);
          this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Fleet Asset - Other Costs');
      }
  };

  //Exports Other Costs table to PDF file
  otherCost_exportToPDF(){
    if(this.othercost_rows.length >0){
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.otherCost_generateColumnsWithFilter(this.othercost_rows);

      //generate json with format header
      this.formatted_list = this.generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      let pdf_file = '[TMS]Fleet_Asset_Other_Costs_' + this.formattedDate(current_date);
      this.exp_pdf.title = 'FLEET OTHER COSTS';
      this.exp_pdf.type = 'pdf';
      this.exp_pdf.list_data = this.formatted_list;
      this.exporter.exportToPDF(this.exp_pdf).subscribe(data=>{
        saveAs(data, pdf_file + '.' + this.exp_pdf.type);
      });
    }
  };

  //Exports Other Costs table to MS Excel file
  otherCost_exportToExcel(){
      if(this.othercost_rows.length >0){
          let with_header_format, with_column_filter;
          
          //generate json with filtered column
          with_column_filter = this.otherCost_generateColumnsWithFilter(this.othercost_rows);

          //generate json with format header
          this.formatted_list = this.generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let excel_file = '[TMS]Fleet_Asset_Other_Costs_' + this.formattedDate(current_date);
          this.exp_excel.title = 'FLEET OTHER COSTS';
          this.exp_excel.type = 'xlsx';
          this.exp_excel.list_data = this.formatted_list;
          this.exporter.exportToExcel(this.exp_excel).subscribe(data=>{
              console.log(data);
              saveAs(data, excel_file)

              //var xlsx_file = new File(data, excel_file, {type: 'xlsx'});
              //saveAs(xlsx_file);

          });
      }
  }; 

  //Returns a date format in the file name
  public formattedDate(d = new Date) {
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());
  
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
  
    return `${day}/${month}/${year}`;
  }

} 



// end component